'use client';

import Link, { LinkProps } from 'next/link';
import { twMerge } from 'tailwind-merge';

import { buttonClasses } from './button.component';
import { ButtonSize, ButtonVariant } from '@homeflow/v4-lib/state';

// TODO: How do we extend this in a way that lets us include AnchorHTMLAttributes
// without having to individually include them all here? (e.g. id)
interface Props extends LinkProps {
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
  title?: string;
  target?: string;
  children: React.ReactNode;
}

export default function LinkButton({
  variant,
  size,
  className,
  children,
  title,
  ...otherProps
}: Props) {
  return (
    <Link
      prefetch={false}
      className={twMerge(buttonClasses(variant, size), className)}
      title={title}
      {...otherProps}
    >
      {children}
    </Link>
  );
}
